import React from 'react';
import { List } from 'immutable';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import AgentDraggable from 'flow/components/dashboard/creation/team-custom/AgentDraggable';
import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey } from 'flow/types/EntityKeys';

interface Props {
    agents: List<ExtensionKey>;
    onUpdate: (keys: List<ExtensionKey>) => void;
}

const AgentsSortableDeletable = ({ agents = List(), onUpdate }: Props) => {
    const { i18next } = useAppContext();

    const onSortEnd = ({
        oldIndex,
        newIndex,
    }: {
        oldIndex: number;
        newIndex: number;
    }) => {
        const itemToMove = agents.get(oldIndex);
        const agentsUpdated = agents
            .delete(oldIndex)
            .insert(newIndex, itemToMove);
        onUpdate(agentsUpdated);
    };

    const onClickDelete = (key: ExtensionKey) => {
        const indexToDelete = agents.findIndex((agentKey) => agentKey === key);
        onUpdate(agents.delete(indexToDelete));
    };

    const SortableItem = SortableElement(({ value }: { value: any }) => {
        return (
            <div className="z-10">
                <AgentDraggable
                    agentKey={value}
                    onClickDelete={onClickDelete}
                />
            </div>
        );
    });

    const SortableList = SortableContainer(
        ({ items }: { items: any /*List<ExtensionKey>*/ }) => {
            return (
                <div className="flex flex-col gap-y-3">
                    {items.map((value: any, index: number) => (
                        <SortableItem
                            key={`item-${index}`}
                            index={index}
                            value={value}
                        />
                    ))}
                </div>
            );
        },
    );

    return (
        <>
            {agents.size ? (
                <SortableList
                    items={agents}
                    onSortEnd={onSortEnd}
                    useDragHandle={true}
                />
            ) : (
                <div className="box-border w-full text-xs text-gray-500">
                    {i18next.t('user_picker.no_users')}
                </div>
            )}
        </>
    );
};

export default React.memo(AgentsSortableDeletable);
